import React, { memo } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import styles from './assets/styles/index.styles'
import Popover from './Popover'
import SecondPartition from './SecondPartition'
import ThirdPartition from './ThirdPartition'
import useElementVisible from '../app/hooks/useElementVisible'
import usePopoverToggles from '../app/hooks/usePopoverToggles'
import VisibilitySensor from '../VisibilitySensor'
import BoxDecoration from '../Decorations/Box'
import { CaratteristichePageConfig } from '../configuration'
import SlideUpHOC from '../SlideUpHOC'
import OnViewPortObserver from '../OnViewPortObserver'
import BlockRevealImage from '../BlockRevealImage'
import AssignID from '../AssignId'
const useStyles = makeStyles(styles)
function Caratteristiche() {
    const [state, setElemVisible] = useElementVisible({
        h1: false,
        p: false,
        image: false
    })
    const [popovers, openPopover, closePopover] = usePopoverToggles({
        first: null,
        second: null,
        third: null
    })
    const classes = useStyles()
    return (
        <>
            <div className={classes.root} >
                <AssignID
                    absolute
                    y='-150px'
                    yMobile='0'
                    id={CaratteristichePageConfig.id}
                />
                <OnViewPortObserver
                    absolute
                    y={CaratteristichePageConfig.firstContainer.imageOffset}
                    yMobile={CaratteristichePageConfig.firstContainer.imageOffsetMobile}
                    onEnterViewPort={() => setElemVisible('image')}
                />
                <BoxDecoration hideMobile left='100%' right={0} top='50%' bottom={0} rotate='45deg' scale='1.5' z={0} />
                <BoxDecoration hideMobile left='100%' right={0} top='50%' bottom={0} rotate='22.5deg' scale='1.5' z={0} />
                <BoxDecoration hideMobile left='100%' right={0} top='50%' bottom={0} rotate='67.5deg' scale='1.5' z={0} />
                <BoxDecoration hideMobile left='100%' right={0} top='50%' bottom={0} rotate='0deg' scale='1.5' z={0} />
                <BlockRevealImage
					blockRevealClass={classes.imgWrap}
					isInView={state.image}
					imageSrc={CaratteristichePageConfig.firstContainer.image}
					imgAlt={CaratteristichePageConfig.firstContainer.alt}
					imgAlt2={CaratteristichePageConfig.firstContainer.alt2}
					imageClass={classes.img}
					captionClass={classes.caption}
					hasOtherElements
					addShadowOnVisible
                />
                <span className={classes.textWrap}>
                    <SlideUpHOC duration='0.8s' when={state.h1} >
                        <h1 className={classes.h1} >{CaratteristichePageConfig.firstContainer.content.primary}</h1>
                    </SlideUpHOC>
                    <OnViewPortObserver
                        absolute
                        y={CaratteristichePageConfig.firstContainer.primaryTextOffset}
                        yMobile={CaratteristichePageConfig.firstContainer.primaryTextOffsetMobile}
                        onEnterViewPort={() => setElemVisible('h1')}
                    />
                    <SlideUpHOC duration='0.8s' when={state.p} >
                        <p className={classes.p} >
                            {CaratteristichePageConfig.firstContainer.content.secondary[0]}
                            <strong className="strong">{CaratteristichePageConfig.firstContainer.content.secondary[1]}</strong>
                            {CaratteristichePageConfig.firstContainer.content.secondary[2]}
                            <strong className="strong">{CaratteristichePageConfig.firstContainer.content.secondary[3]}</strong>
                            {CaratteristichePageConfig.firstContainer.content.secondary[4]}
                        </p>
                    </SlideUpHOC>
                    <SlideUpHOC duration='0.8s' when={state.p} >
                        <p className={classes.p} >
                            {CaratteristichePageConfig.firstContainer.content.tertiary[0]}
                            <strong className="strong">{CaratteristichePageConfig.firstContainer.content.tertiary[1]}</strong>
                            {CaratteristichePageConfig.firstContainer.content.tertiary[2]}
                        </p>
                    </SlideUpHOC>
                    <OnViewPortObserver
                        absolute
                        y={CaratteristichePageConfig.firstContainer.subTextOffset}
                        yMobile={CaratteristichePageConfig.firstContainer.subTextOffsetMobile}
                        onEnterViewPort={() => setElemVisible('p')}
                    />
                </span>
            </div>
            <SecondPartition />

        </>
    )
}

export default memo(Caratteristiche)